import { createContext, useContext, useState, ReactNode } from 'react';

type ImpersonationContextValue = {
  impersonateUserId: string | null;
  setImpersonateUserId: (id: string | null) => void;
};

const ImpersonationContext = createContext<ImpersonationContextValue | null>(null);

export const ImpersonationProvider = ({ children }: { children: ReactNode }) => {
  const [impersonateUserId, setImpersonateUserId] = useState<string | null>(null);

  return (
    <ImpersonationContext.Provider value={{ impersonateUserId, setImpersonateUserId }}>
      {children}
    </ImpersonationContext.Provider>
  );
};

export const useImpersonation = () => {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error('useImpersonation must be used within ImpersonationProvider');
  }
  return context;
};
